import { FC } from 'react'
import styles from './index.module.scss'

type Props = {
  sanitizedHtml: string
}

export const EditorContent: FC<Props> = ({ sanitizedHtml }) => {
  /* eslint-disable react/no-danger */
  return <div className={styles.container} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
  /* eslint-enable react/no-danger */
}
